// extracted by mini-css-extract-plugin
module.exports = {"breakpointTablet":"768px","creditsRating":"CreditsRatingCard_creditsRating__E_P_i","subTitle":"CreditsRatingCard_subTitle__8hBND"};